import {renderField} from "./utils";

export const boolShould = (body: string, boost = 0) => {
  return `
    {
      bool: {
        ${renderField('boost', boost)}
        should: [
          ${body}
        ]
      }
    }
  `;
};

export const boolMust = (body: string, boost = 0) => {
  return `
    {
      bool: {
        ${renderField('boost', boost)}
        must: [
          ${body}
        ]
      }
    }
  `;
};

export const bool = {
  must: boolMust,
  should: boolShould
};
